import type { ComponentType } from 'react'

import type { SDIconProps } from '@/shared/icons/SDIcon'
import { FaceButton } from './styled-components'

interface PollFaceButtonProps {
  Icon: ComponentType<SDIconProps>
  colorKey: string
  softColorKey: string
  label: string
  selected: boolean
  dimmed: boolean
  onSelect: () => void
}

const PollFaceButton = ({ Icon, colorKey, softColorKey, label, selected, dimmed, onSelect }: PollFaceButtonProps) => (
  <FaceButton
    type='button'
    title={label}
    aria-label={label}
    aria-pressed={selected}
    $colorKey={colorKey}
    $softColorKey={softColorKey}
    $selected={selected}
    $dimmed={dimmed}
    onClick={onSelect}
  >
    <Icon size={20} />
  </FaceButton>
)

export default PollFaceButton
